import { Button, Form, Input, InputNumber, Switch, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

export default function PricingDetail() {
  const { slug } = useParams();
  const isCreate = slug === 'create';
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const fetchPackage = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/pricing/getById/${slug}`);
      form.setFieldsValue({
        ...res?.data,
        is_popular: !!res?.data?.is_popular,
        is_active: !!res?.data?.is_active,
      });
    } catch {
      message.error("Lỗi tải dữ liệu!");
    }
  };

  useEffect(() => {
    if (!isCreate) fetchPackage();
  }, [slug]);

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const data = {
        ...values,
        is_popular: values.is_popular ? 1 : 0,
        is_active: values.is_active ? 1 : 0,
      };

      if (isCreate) {
        await axios.post(`${process.env.REACT_APP_API_URL}/pricing/create`, data);
        message.success("Tạo gói giá thành công!");
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/pricing/update/${slug}`, data);
        message.success("Cập nhật gói giá thành công!");
      }
      navigate('/admin/pricing');
    } catch {
      message.error("Thao tác thất bại!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5">
      <div className="text-[20px] font-medium pb-5">{isCreate ? 'Tạo gói giá mới' : 'Chỉnh sửa gói giá'}</div>
      <div className="bg-white p-6 rounded-lg shadow max-w-2xl">
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          initialValues={{ is_active: true, is_popular: false, duration_days: 30 }}
        >
          <Form.Item name="name" label="Tên gói" rules={[{ required: true, message: 'Vui lòng nhập tên!' }]}>
            <Input size="large" placeholder="VD: Gói 1 Tháng" />
          </Form.Item>
          <Form.Item name="price" label="Giá (VNĐ)" rules={[{ required: true, message: 'Vui lòng nhập giá!' }]}>
            <InputNumber size="large" className="w-full" min={0} step={1000} formatter={v => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} parser={v => v.replace(/,/g, '')} />
          </Form.Item>
          <Form.Item name="duration_days" label="Thời hạn (ngày)" rules={[{ required: true }]}>
            <InputNumber size="large" className="w-full" min={1} />
          </Form.Item>
          <Form.Item name="description" label="Mô tả">
            <Input.TextArea rows={3} placeholder="Mô tả ngắn về gói..." />
          </Form.Item>
          <Form.Item name="features" label="Tính năng (mỗi dòng 1 tính năng)">
            <Input.TextArea rows={5} placeholder="Truy cập tất cả bài học&#10;Luyện nói với AI&#10;..." />
          </Form.Item>
          <Form.Item name="is_popular" label="Đánh dấu phổ biến" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item name="is_active" label="Đang hoạt động" valuePropName="checked">
            <Switch />
          </Form.Item>
          <div className="flex gap-3">
            <Button type="primary" htmlType="submit" loading={loading} className="bg-blue-500">
              {isCreate ? 'Tạo gói' : 'Cập nhật'}
            </Button>
            <Button onClick={() => navigate('/admin/pricing')}>Quay lại</Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
